export default {"src":"/_next/static/media/element-logo.b27fdfe4.svg","height":74,"width":66};